module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"showMore":"查看更多>","auctionSessions":"同步拍卖","finished":"拍卖已结束"},"zh_hk":{"showMore":"查看更多>","auctionSessions":"同步拍賣","finished":"拍賣已結束"},"en":{"showMore":"See more>","auctionSessions":"Live Auction","finished":"Past auctions"},"ja":{"showMore":"もっと見る>","auctionSessions":"ライブオークション","finished":"オークションは終了しました"}}')
  delete Component.options._Ctor
}
